import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';


export const fetchArticlesExternal = createAsyncThunk(
  'articlesExternal/fetchArticlesExternal',
  async ({ businessName, group_id }, { getState, rejectWithValue }) => {
    try {
      const url = `${ROOT_URL}/kb/articles/all/external/${businessName}`;
      const response = await axios.get(url, {
        params: group_id ? { group_id } : undefined,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching featured articles:', error);
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch featured articles'
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  articles: [],
};

const articlesExternalSlice = createSlice({
  name: 'articlesExternal',
  initialState,
  reducers: {
    resetArticlesExternal: (state) => {
      return initialState;
    },
    clearFeaturedError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArticlesExternal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchArticlesExternal.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        const articlesList = action.payload.data || [];

        state.articles = articlesList.map(article => ({
          ...article,
          id: article._id,
          // Map categoryIds array to a single category string for display compatibility
          category: article.categoryIds && article.categoryIds.length > 0 ? article.categoryIds[0].name : '-',
          // Ensure title is present (it is in the sample)
          // Add isFeatured: true explicitly since these are featured articles
          isFeatured: true
        }));
      })
      .addCase(fetchArticlesExternal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.articles = [];
      })

  }
});

export const { resetArticlesExternal, clearFeaturedError } = articlesExternalSlice.actions;

export default articlesExternalSlice.reducer;
